module.exports = __webpack_public_path__ + "img/greydot.d8dfe13c.svg";